// @ts-ignore
import IconFont from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
export default `
@font-face {
  src: url(${IconFont});
  font-family: MaterialCommunityIcons;
}
`;
//# sourceMappingURL=fontFace.js.map